// Artwork exported from the Figma frame "VIP / bonuses / arcade games" (3618:68740) on the
// PAVEL DRAFT page, via the Dev Mode asset server.
import ArcadeChipPng from './chip.png';
import DailyBonusCoinsPng from './coins.png';
import DailyBonusStarSvg from './daily-bonus-star.svg';
import DayArrowSvg from './day-arrow.svg';
import DayCollectedSvg from './day-collected.svg';
// The game art from "16/10 VIP / bonuses / arcade games" (7019:79805), cut from the file's
// 1254-square exports to 3x their card size: the featured games' round medallions keep their
// alpha (312 for the 102 slot), the VIP tiles are opaque squares (216 for the 72 slot).
import CrashJpg from './games/crash.jpg';
import CrossyRoadJpg from './games/crossy-road.jpg';
import HigherLowerJpg from './games/higher-lower.jpg';
import LuckyWheelJpg from './games/lucky-wheel.jpg';
import PenaltyShootoutsJpg from './games/penalty-shootouts.jpg';
import PlinkoJpg from './games/plinko.jpg';
import RedOrBlackPng from './games/red-or-black.png';
import ScratchPng from './games/scratch.png';
import SlotPng from './games/slot.png';
import TreasureChestsJpg from './games/treasure-chests.jpg';
import VipCoinsPng from './vip-coins.png';
import VipCrownPng from './vip-crown.png';
// The VIP Ticket the arcade takes as a round's entry, cropped to the ticket and cut to 256 square.
import VipTicketPng from './vip-ticket.png';

export {
	ArcadeChipPng,
	CrashJpg,
	CrossyRoadJpg,
	DailyBonusCoinsPng,
	DailyBonusStarSvg,
	DayArrowSvg,
	DayCollectedSvg,
	HigherLowerJpg,
	LuckyWheelJpg,
	PenaltyShootoutsJpg,
	PlinkoJpg,
	RedOrBlackPng,
	ScratchPng,
	SlotPng,
	TreasureChestsJpg,
	VipCrownPng,
	VipTicketPng,
	VipCoinsPng,
};
